import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';

import {
  extractSchema,
  normalizeFormErrors,
  toastifyResponseError,
} from '@utils';

import { Button, Field, Theme } from '@components';
import { PlatformAppsDevInstallingConstructor } from '@components/Ui/PlatformApps/PlatformAppsDevInstallingConstructor';

const toObject = (input: string): unknown => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-implied-eval
    return new Function(`return (${input})`)();
  } catch {
    return null;
  }
};

type Schema = z.infer<typeof schema>;

const schema = z.object({
  schema: z.string().nonempty('Required'),
});

export const PlatformAppsDevSchemaPage: React.FC = () => {
  const { register, handleSubmit, formState } = useForm<Schema>({
    resolver: zodResolver(schema),
  });

  const [devSchema, setDevSchema] = useState(null);

  const errors = normalizeFormErrors<keyof Schema>(formState.errors);

  const handleSubmitForm = handleSubmit(({ schema }) => {
    try {
      const formattedSchema = toObject(schema) as any;

      /**
       * Validate JSON Schema
       */
      extractSchema(formattedSchema);

      setDevSchema(formattedSchema);
    } catch (error) {
      toastifyResponseError(error);
    }
  });

  return (
    <>
      <Theme.Container>
        <form onSubmit={handleSubmitForm}>
          <Field.Textarea
            {...register('schema')}
            resizable
            required
            label="JSON Schema"
            error={errors.schema}
            note="Template's input only"
          />
          <Button className="ml-auto mt-8 flex px-10" type="submit">
            Apply
          </Button>
        </form>
      </Theme.Container>
      {devSchema && <PlatformAppsDevInstallingConstructor input={devSchema} />}
    </>
  );
};
